<template>
  <ExampleStory>
    <TfPagination
      v-bind="{
        isDisabled: model.isDisabled,
        value: Number(model.pageSelected),
        totalPages: Number(model.totalPages),
      }"
      @input="onEmit('input', $event)"
    />
    <template #controls>
      <div>
        <h3>model:</h3>
        <pre>{{ model.pageSelected }}</pre>
      </div>
      <div>
        <ElForm label-position="top">
          <h3>Props</h3>
          <TfFormBuilder
            v-model="model"
            v-bind="{
              formItems,
              isLoaded: true,
            }"
          />
        </ElForm>
      </div>
      <div>
        <h3>@emits:</h3>
        <div
          v-for="({ name, payload }, index) in emits"
          :key="index"
          class="emit"
        >
          <h4>name: {{ name }}</h4>
          <pre>{{ payload }}</pre>
        </div>
      </div>
    </template>
  </ExampleStory>
</template>

<script>
  import ExampleStory from '@/views/examples/Layouts/Story';

  export default {
    name: 'ExampleTableStories',
    components: { ExampleStory },
    data: () => ({
      emits: [],
      model: {
        isDisabled: false,
        pageSelected: 1,
        totalPages: 5,
      },
    }),
    computed: {
      /**
       * Creates the framework for the props form items.
       *
       * @returns {Array}
       */
      formItems() {
        return [
          [
            {
              props: {
                label: 'totalPages',
                min: 1,
                prop: 'totalPages',
                type: 'number',
              },
            },
            {
              props: {
                label: 'pageSelected',
                min: 1,
                max: this.model.totalPages,
                prop: 'pageSelected',
                type: 'number',
              },
            },
          ],
          [{
            props: {
              label: 'isDisabled',
              prop: 'isDisabled',
              type: 'switch',
            },
          }],
        ];
      },
    },
    methods: {
      /**
       * Updates the `payloads.emitted` object to the latest payload for display only purposes.
       *
       * @param {string} name
       * @param {object} payload
       */
      onEmit(name, payload) {
        this.emits.unshift({ name, payload });

        if (name === 'input') {
          this.model.pageSelected = Number(payload);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/assets/styles/variables';

  .emit {
    padding: 10px 0;
    border-bottom: 1px solid $tf-extra-light-gray-1;
  }
</style>
